import { BsFillTrashFill } from 'react-icons/bs'
import html2canvas from 'html2canvas'
import { useState } from 'react'
// import { Loading } from '../Loading'
import { AiFillCamera } from 'react-icons/ai'
import { Button, Flex, Spinner } from '@chakra-ui/react'
import { ViewScreenshot } from './ViewScreenshot'

export function ScreenshotButton({ screenshot, onScreenshotTook }) {
  const [isTakingScreenshot, setIsTakingScreenshot] = useState(false)

  async function handleTakeScreenshot() {
    setIsTakingScreenshot(true)

    //tirar foto da tela
    const canvas = await html2canvas(document.body)

    const base64Image = canvas.toDataURL('image/png')

    onScreenshotTook(base64Image)
    setIsTakingScreenshot(false)
  }

  if (screenshot) {
    return (
      <Flex gap={2}>
        <Button
          type="button"
          colorScheme="red"
          // onClick={() => onScreenshotTook(null)}
          style={{
            backgroundImage: `url(${screenshot})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
          alignSelf="flex-start"
        />

        <Flex gap={2}>
          {/* <ViewScreenshot screenshot={screenshot} /> */}
          <Button
            onClick={() => onScreenshotTook(null)}
            alignSelf="flex-start"
            colorScheme="red"
            type="button"
          >
            <BsFillTrashFill />
          </Button>
        </Flex>
      </Flex>
    )
  }

  return (
    <Button
      onClick={handleTakeScreenshot}
      alignSelf="flex-start"
      colorScheme="blue"
      type="button"
    >
      {isTakingScreenshot ? (
        <Spinner size="sm" color="white" />
      ) : (
        <AiFillCamera size="2rem" color="white" />
      )}
    </Button>
  )
}
